const getEmailFromGraphAPI = async (accessToken) => {
  try {
    const response = await fetch('https://graph.microsoft.com/v1.0/me', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch user information from Graph API');
    }

    const data = await response.json();
    return data.mail || data.userPrincipalName; // Fallback if mail is not available
  } catch (error) {
    console.error('Error fetching email:', error);
    return null;
  }
};

export default async function fetchAttachmentFileNamesForOutlook(
  selectedEmails,
  accessToken,
) {
  try {
    if (selectedEmails) {
      const attachments = [];
      const emailResult = await getEmailFromGraphAPI(accessToken);
      const allowedFileTypes = [
        'image/jpeg',
        'image/jpg',
        'image/png',
        'application/pdf',
      ];
      const maxSizeInBytes = 10 * 1024 * 1024;

      selectedEmails?.forEach((email) => {
        if (email.attachments.length > 0) {
          email.attachments.forEach((attachment) => {
            if (
              attachment.name &&
              allowedFileTypes.includes(attachment.contentType)
            ) {
              if (attachment.size > maxSizeInBytes) {
                console.log(`File '${attachment.name}' is larger than 10MB.`);
                return; // Skip this file
              }
              const downloadUrl =
                attachment['@microsoft.graph.downloadUrl'] ||
                `https://graph.microsoft.com/v1.0/me/messages/${email.id}/attachments/${attachment.id}/$value`;
              const fileName = attachment.name;
              if (/^[^\s!@#$%^&*]+$/.test(fileName)) {
                attachments.push({
                  downloadUrl,
                  mimeType: attachment.contentType,
                  name: fileName,
                });
              } else {
                console.log(`Filename '${fileName}' does not pass regex test.`);
              }
            }
          });
        }
      });
      return {
        files: attachments,
        accessToken,
        email: emailResult,
      };
    }
    throw new Error('Failed to fetch attachment file names');
  } catch (error) {
    console.log('Error fetching attachment file names:', error);
    throw error;
  }
}
